/** 与 m-mall-dc 共用：任意页 ?source=cmdc 时写入，会话内不主动清除（关标签页后 sessionStorage 自然失效） */
export const TRAFFIC_SOURCE_KEY = 'traffic_source';
const CMDC_SOURCE = 'cmdc';

/** 任意页调用：当前 URL / query 带 cmdc 则写入 storage */
export function captureTrafficSourceFromQuery(query = {}) {
	if (typeof sessionStorage === 'undefined') return;

	if (typeof window !== 'undefined') {
		const fromUrl = new URLSearchParams(window.location.search).get('source');
		if (fromUrl === CMDC_SOURCE) {
			sessionStorage.setItem(TRAFFIC_SOURCE_KEY, CMDC_SOURCE);
			return;
		}
	}

	if (query?.source === CMDC_SOURCE) {
		sessionStorage.setItem(TRAFFIC_SOURCE_KEY, CMDC_SOURCE);
	}
}

export function isCmdcTrafficSource() {
	if (typeof sessionStorage === 'undefined') return false;
	return sessionStorage.getItem(TRAFFIC_SOURCE_KEY) === CMDC_SOURCE;
}
